import Vue from 'vue'
import VueCookies from 'vue-cookies'
import router from '../../router'
import api from '../../api/leadRealAPI'

Vue.use(VueCookies)

export default {
  namespaced: true,
  state: {
    email: null,
    processState: false
  },

  getters: {
    user: state => state.userData,
    processState: state => state.processState
  },

  mutations: {
    setEmail (state, email) {
      state.email = email
    },
    setProcessState (state, process) {
      state.processState = process
    }
  },
  actions: {
    forget_password ({ commit }, data) {
      api.post('forgetPassword', data)
        .then(response => {
          if (response.data.email_address) {
            commit('setErrors', response.data.email_address, { root: true })
          } else {
            commit('setProcessState', true)
          }
        }).catch(() => {})
    },
    verifyToken ({ commit }, data) {
      api.post('verifyTokenRoute', data)
        .then(response => {
          if (response.status === 200) {
            router.push({ name: 'New Password' })
            commit('setEmail', data.email_address)
          }
        }).catch((error) => {
          if (error) {
            router.push({ name: 'Client 404', params: { lang: router.currentRoute.params.lang } })
          }
        })
    },
    resetPassword ({ commit }, data) {
      api.post('password/reset/admin', data)
        .then(response => {
          commit('setProcessState', true)
        }).catch(() => {})
    }
  }
}
